import {IPsoAgreementCommonFormFields, IPsoAgreementViewModel} from "../base/pso-agreement.view-mode.interface";
import {IPsoFamilySpecificDegreeTypeViewModel} from "./options/pso-family-specific-degree-type.view-model.interface";
import {Check} from "../../../../../../types/type-checking";

export interface IPsoFamilyAgreementViewModel extends IPsoAgreementViewModel<IPsoFamilyAgreementFormFields> {
    specificDegreeOfKinshipOptions: IPsoFamilySpecificDegreeTypeViewModel[];
}

export enum DegreeOfKinshipTypeEnum {
    FirstDegree = 1,
    SecondDegree = 2,
    ThirdDegree = 3,
    BeneficiaryOfExtraordinaryLeaveAndPermit = 4,
    LegalGuardian = 5
}

export enum SpecificDegreeOfKinshipTypeEnum {
    Spouse = 1,
    Child = 2,
    Parent = 3
}

export interface IPsoFamilyAgreementFormFields extends IPsoAgreementCommonFormFields {
    degreeOfKinshipType: DegreeOfKinshipTypeEnum;
    degreeOfKinshipDescription: string;
    guardianshipIssuedByCourt: string;
    guardianshipIssueDate: Date;
    guardianshipDocumentNumber: string;
    specificDegreeOfKinshipType: SpecificDegreeOfKinshipTypeEnum;
    specificDegreeOfKinshipFullName: string;
    residentFullName: string;
    residentMunicipality: string;
    residentAddress: string;
    residentEmail: string;
    residentPhone: string;
    residentPhoneCountryCode: string;
}

export function isInFirst3Degrees(degreeOfKinshipType: DegreeOfKinshipTypeEnum | null): boolean {
    if(Check.isNullOrUndefined(degreeOfKinshipType)) {
        return false;
    }
    return [
        DegreeOfKinshipTypeEnum.FirstDegree,
        DegreeOfKinshipTypeEnum.SecondDegree,
        DegreeOfKinshipTypeEnum.ThirdDegree].includes(degreeOfKinshipType)
}